/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { AlertBar } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  errorContainer: {
    maxWidth: 600,
  },
  mediumMargin: {
    marginBottom: 16,
  },
  smallMargin: {
    marginBottom: 8,
  },
});

export interface TaskErrorProps {
  errorMessage: string;
  showDismiss?: boolean;
  showIcon?: boolean;
  spacing?: 'sm' | 'md';
}

export const TaskError: React.FC<TaskErrorProps> = ({
  errorMessage,
  showDismiss = false,
  showIcon,
  spacing = 'md',
}) => {
  const icon = showIcon ? 'error' : undefined;
  const marginStyle = spacing === 'sm' ? css(styles.smallMargin) : css(styles.mediumMargin);
  const className = [css(styles.errorContainer), marginStyle].join(' ');
  const [isErrorOpen, setErrorOpen] = useState<boolean>(true);

  const confirmProps = showDismiss ? { confirmText: 'Dismiss', onConfirm: () => setErrorOpen(false) } : undefined;
  return (
    <div className={className}>
      {isErrorOpen && (
        <AlertBar
          confirmProps={confirmProps}
          icon={icon}
          id="it-dashboard-tasks-errors"
          message={errorMessage}
          theme="error"
        />
      )}
    </div>
  );
};
